var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWarning(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1222_38152)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.89003 1.0499C7.80611 0.886097 7.67861 0.748632 7.52158 0.652642C7.36455 0.556651 7.18407 0.505859 7.00003 0.505859C6.81598 0.505859 6.6355 0.556651 6.47847 0.652642C6.32144 0.748632 6.19394 0.886097 6.11003 1.0499L0.610026 12.0499C0.533316 12.2021 0.496794 12.3714 0.503928 12.5418C0.511062 12.7121 0.561616 12.8777 0.650789 13.023C0.739961 13.1683 0.864792 13.2884 1.01343 13.3718C1.16206 13.4553 1.32956 13.4994 1.50003 13.4999H12.5C12.6705 13.4994 12.838 13.4553 12.9866 13.3718C13.1353 13.2884 13.2601 13.1683 13.3493 13.023C13.4384 12.8777 13.489 12.7121 13.4961 12.5418C13.5033 12.3714 13.4667 12.2021 13.39 12.0499L7.89003 1.0499Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7 5V8.25",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7 11C6.86193 11 6.75 10.8881 6.75 10.75C6.75 10.6119 6.86193 10.5 7 10.5",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7 11C7.13807 11 7.25 10.8881 7.25 10.75C7.25 10.6119 7.13807 10.5 7 10.5",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1222_38152"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/warning.fa35841682ac999f41b103698365f92f.svg";
export { ForwardRef as ReactComponent };